import SecondaryTab from './SecondaryTab';

export default SecondaryTab;
